// @ts-nocheck
export default {
    languageCodes: {
        FR_CA: "fr-CA",
        EN_CA: "en-CA",
    },
    availabilityCodes: {
        InStock: "InStock",
        OutOfStock: "TemporaryOutofStock",
        OnDemand: "OnDemand",
        Discontinued: "Discontinued",
    },
    carouselIds: {
        videoCarousel: "video-carousel-id",
    },
    productRelation: {
        SimilarProduct: "Similar Product",
        SparePart: "Spare Part",
        RequiredAccessory: "Required Accessory",
        FormatAvailable: "Format Available",
    },
};
